<template>
  <div>
    <!-- 题型1，矩阵量表题 -->
    <SubScale v-if="question.type===1" :question="question" v-on:listenToChildEvent="listenToChildEvent"></SubScale>
    <!-- 题型2，单选题-->
    <SelectRadio v-if="question.type===2" :question="question" v-on:listenToChildEvent="listenToChildEvent"></SelectRadio>
    <!-- 题型3，单项量表（评分）题 -->
    <RateScale v-if="question.type===3" :question="question" v-on:listenToChildEvent="listenToChildEvent"></RateScale>
    <!-- 题型4，单项多选题 -->
    <CheckBox v-if="question.type===4" :question="question" v-on:listenToChildEvent="listenToChildEvent"></CheckBox>
    <!-- 题型5，矩阵选择题 -->
    <TextRadio v-if="question.type===5" :question="question" v-on:listenToChildEvent="listenToChildEvent"></TextRadio>
    <!-- 题型6，单项填空 -->
    <TextInput v-if="question.type===6" :question="question" v-on:listenToChildEvent="listenToChildEvent"></TextInput>
    <!-- 题型10，排序 -->
    <SortLi v-if="question.type===10"  :question="question" v-on:listenToChildEvent="listenToChildEvent"></SortLi>
    <!-- 题型12，选择互斥题 -->
    <MutualRadio v-if="question.type===12"  :question="question" v-on:listenToChildEvent="listenToChildEvent"></MutualRadio>
  </div>
</template>
<script>
import SubScale from '../components/SubScale';
import SelectRadio from '../components/SelectRadio'
import RateScale from '../components/RateScale'
import CheckBox from '../components/CheckBox'
import TextRadio from '../components/TextRadio'
import TextInput from '../components/TextInput';
import SortLi from '../components/SortLi';
import MutualRadio from '../components/MutualRadio'
export default {
  props:{
    desc: String,
    question: Object
  },
  components: {
    'SubScale': SubScale,
    'SelectRadio':SelectRadio,
    'RateScale':RateScale,
    'CheckBox':CheckBox,
    'TextRadio':TextRadio,
    'TextInput':TextInput,
    'SortLi': SortLi,
    'MutualRadio':MutualRadio
  },
  methods: {
    // 点击事件
    listenToChildEvent(num, answer, question, ...paramList){
        this.$emit("listenToChildEvent", num, answer, question, ...paramList);
    }
  }
}
</script>
<style scoped>
</style>
